export const ROUNDING_OCCURRENCE_STATUS = {
  CREATED: 0,
  ACCEPTED: 1,
  STARTED: 2,
  PAUSED: 3,
  COMPLETED: 4,
} as const;

export const ROUNDING_OCCURRENCE_VALIDITY_STATUS = {
  /** 0 faults noted. */
  VALID: 0,
  /** More than 0 faults noted. */
  INVALID: 1,
} as const;
